import { useState } from "react";
import { Link } from "react-router-dom";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { approveReport, fetchReports } from "../../api/HrAPIs";
import { Empty, HrFrame, HrGuard, StatusPill, useHr } from "./hrUi";

export default function ReportsPage() {
  return <HrGuard anyOf={["HR.ViewReports", "HR.CreateReports", "HR.ManageNotes"]}><Body /></HrGuard>;
}

function Body() {
  const hr = useHr();
  const queryClient = useQueryClient();
  const now = new Date();
  const [year, setYear] = useState(now.getFullYear());
  const [month, setMonth] = useState(now.getMonth() + 1);
  const reports = useQuery({ queryKey: ["hrReports", year, month], queryFn: () => fetchReports({ year, month }) });
  return (
    <HrFrame title="التقارير والملاحظات" subtitle="التقرير الشهري منفصل عن الملاحظات الداخلية. تعديل المعتمد يُسجل في المراجعة.">
      <div className="mb-4 flex gap-2">
        <input className="rounded-xl border px-3 py-2" type="number" value={year} onChange={(event) => setYear(Number(event.target.value))} />
        <input className="rounded-xl border px-3 py-2" type="number" min="1" max="12" value={month} onChange={(event) => setMonth(Number(event.target.value))} />
      </div>
      {(reports.data || []).length === 0 && <Empty text="لا توجد تقارير لهذا الشهر. تُنشأ من ملف الموظف." />}
      {(reports.data || []).map((report) => (
        <div key={report.id} className="mb-2 flex flex-wrap items-center justify-between gap-2 rounded-2xl border bg-white p-3">
          <Link className="font-semibold text-indigo-700" to={`/hr/employees/${report.employeeId}`}>{report.employeeName}</Link>
          <span className="flex items-center gap-2 text-sm">
            {report.rating}/10 <StatusPill value={report.status} />
            {report.status === "Submitted" && hr.can("HR.ViewReports") && (
              <button type="button" onClick={() => approveReport(report.id).then(() => { toast.success("تم الاعتماد"); queryClient.invalidateQueries({ queryKey: ["hrReports"] }); }).catch((error) => toast.error(error.message))}>اعتماد</button>
            )}
          </span>
        </div>
      ))}
    </HrFrame>
  );
}
